export enum RSPlatforms {
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
}

export enum EcommercePlatforms {
  SHOPIFY = 'shopify',
  WOOCOMMERCE = 'woocommerce',
}
